"use strict";
/**
 * LocalStorageLRU
 * Copyright 2022 SageMath, Inc.
 * Licensed under the Apache License, Version 2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageLRU = void 0;
var local_storage_lru_1 = require("./local-storage-lru");
Object.defineProperty(exports, "LocalStorageLRU", { enumerable: true, get: function () { return local_storage_lru_1.LocalStorageLRU; } });
